import React from 'react';
import { linePropTypes } from '../../model';

export const Line = ({ className = '' }) => <div className={className} />;

Line.propTypes = linePropTypes;
